import React from "react";
import Typography from "@material-ui/core/Typography";
import CardImportar from "../components/CardImportar";
import useToken from "../useToken";
import {importacionesResources, wallmartResources} from "../endpoints";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {Card, CardActions, CardHeader} from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import { Redirect } from "react-router-dom";

class Importaciones extends React.Component{
    constructor(props) {
        super(props);

        this.state={
            importaciones:[],
            get_item_file: false,
            cliente: null,
            openFile: false,
            openCount:false,
            progress: false,
            disabled: false,
            severityFile: null,
            severityCount: null,
            messageFile: null,
            messageCount: null

        }
    }
    getItemFile =()=>{
        wallmartResources.getItemFile().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message.correcto){
                this.setState({
                    openFile: true,
                    messageFile: result.message.correcto,
                    severityFile: result.severity})
            }
            else if(result.message.response){
                this.setState({
                    openFile: true,
                    messageFile: result.message.response.description,
                    severityFile: result.severity})
            }
            else if(result.message.error){
                this.setState({
                    openFile: true,
                    messageFile: result.message.error.description,
                    severityFile:'error'})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error)
            this.setState({
                openFile: true,
                messageFile: "Ha ocurrido un error inesperado",
                severityFile: "error"})
        });
    };

    putConteo =()=>{
        wallmartResources.putCount().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.setState({
                    openCount: true,
                    messageCount: result.message.description,
                    severityCount: result.severity})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error)
            this.setState({
                openCount: true,
                messageCount: "Ha ocurrido un error inesperado",
                severityCount: "error"})
        });
    };

    componentDidMount() {
        let datos_inv = useToken.getDatos()
        const verifyFolio = useToken.verifyToken()
        if(!verifyFolio){
            this.props.history.push('/inventarios');
        }
        else{
            importacionesResources.obtenerImportaciones().then(async response => {
                if (response.ok) {
                    return await response.json();
                } else {
                    throw new Error('Something went wrong ...');
                }
            }).then(result => {
            this.setState({importaciones:result})
            }).catch(error=> {
                console.log(error)
            });
            this.setState({cliente:datos_inv.app})
        }
    }
    
    
    render() {
        const verifyFolio = useToken.verifyToken()

        if(!verifyFolio){
            return <Redirect to="/inventarios"/>
        }
        else{
            return (
                <div>
                    <Typography variant="h4" gutterBottom>
                        Importaciones
                    </Typography>
                    {(this.state.cliente === 'walmart' || this.state.cliente === 'walmart_parciales') &&
                        <Grid container direction="row" alignItems="center" spacing={2}>
                            <Grid item>
                                <Card style={{backgroundColor: "#90caf9", display: 'inline-grid'}}>
                                    <CardHeader title=" 1. Descargar maestro/ITEMFILE"/>
                                    <CardActions>
                                        <Button onClick={this.getItemFile} variant="contained" color="primary">
                                            Descargar
                                        </Button>
                                    </CardActions>
                                    {this.state.openFile ?
                                    <Collapse in={this.state.openFile}>
                                        <Alert
                                            variant="filled"
                                            severity={this.state.severityFile}
                                            action={
                                                <IconButton
                                                    aria-label="close"
                                                    color="inherit"
                                                    size="small"
                                                    onClick={() => {
                                                        this.setState({openFile: false});
                                                    }}
                                                >
                                                    <CloseIcon fontSize="inherit" />
                                                </IconButton>
                                            }
                                        >
                                            {this.state.messageFile}
                                        </Alert>
                                    </Collapse> : null}
                                </Card>
                            </Grid>
                            <Grid>
                                <Card style={{backgroundColor: "#90caf9",display: 'inline-grid'}}>
                                    <CardHeader title=" 2. Enviar lineas maestro"/>
                                    <CardActions>
                                        <Button onClick={this.putConteo} variant="contained" color="primary">
                                            Enviar
                                        </Button>
                                    </CardActions>
                                    {this.state.openCount ?
                                        <Collapse in={this.state.openCount}>
                                            <Alert
                                                variant="filled"
                                                severity={this.state.severityCount}
                                                action={
                                                    <IconButton
                                                        aria-label="close"
                                                        color="inherit"
                                                        size="small"
                                                        onClick={() => {
                                                            this.setState({openCount: false});
                                                        }}
                                                    >
                                                        <CloseIcon fontSize="inherit" />
                                                    </IconButton>
                                                }
                                            >
                                                {this.state.messageCount}
                                            </Alert>
                                        </Collapse> : null}
                                </Card>
                            </Grid>
                        </Grid>}
                    <Grid container direction="row" alignItems="center" spacing={2}>
                        {this.state.importaciones.map((importacion) => {
                            return <Grid item key={importacion.nombre}>
                                <CardImportar title={importacion.nombre} endpoint={importacion.endpoint}
                                            extension={importacion.extension}/>
                            </Grid>
                        })}
                    </Grid>
                </div>
            );
        }
    }
}
export default Importaciones;